import React from 'react';
import { Tag } from 'antd';

export const knownIssuesColumns = (length) => {
    return [
        {
            title: () => {
                return (
                    <>
                        Issue Number <Tag color="processing">{length}</Tag>
                    </>
                );
            },
            dataIndex: 'jira_id',
            key: 'jira_id',
            width: 150,
            render: (text) => (
                <a target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            ),
            sorter: (a, b) => (a.jira_id ? a.jira_id.localeCompare(b.jira_id) : 1),
        },
        {
            title: 'Category',
            dataIndex: 'product_category',
            key: 'product_category',
            width: 200,
            sorter: (a, b) => (a.product_category ? a.product_category.localeCompare(b.product_category) : 1),
        },
        {
            title: 'Description',
            dataIndex: 'ki_description',
            key: 'ki_description',
            ellipsis: true,
        },
    ];
};

export const tabPageCss = {
    padding: '0',
    marginBottom: '0',
};
